import {Checkbox} from 'primereact/checkbox'

const CheckboxButton = ({label = '', checked = false, key, ...props}) => {
    return (
        <div
            key={key}
            className={`flex align-items-center justify-content-between m-2 ml-0 p-2 border-round border-2  ${
                checked
                    ? 'bg-teal-50 text-teal-600 border-teal-50'
                    : 'border-gray-50 bg-gray-50 text-700'
            }`}
            {...props}>
            <div className="flex align-items-center mr-5">
                <label
                    className={`mx-2 ${'select-auto cursor-pointer'} font-bold`}>
                    {label}
                </label>
            </div>
            <Checkbox checked={checked} />
        </div>
    )
}

export default CheckboxButton
